<body class="login-body">

<form #loginForm="ngForm" (keyup.enter)="onClickProceedToLogin()">
  <h1>Welcome</h1>

  <div class="login-panel ui-fluid">
    <div class="instruction-text">Please provide your organization's identifier to login</div>

    <div class="p-grid">
      <div class="p-col-12">
        <label>Company ID</label>
        <div class="input-wrapper">
          <input type="text" autocomplete="off" name="realm" class="ui-inputtext ui-widget" placeholder="Enter company id"
                 [(ngModel)]="realm" (ngModelChange)="errorToolTipMsg=null" required>
          <img src="assets/layout/images/login/user.png" class="user-icon">
        </div>
        <div class="terms-agreement">By continuing, you agree to OneLynk's <a href="{{RouteLink.OneLynkTermsAndConditions}}" target="_blank">Terms of Use</a>
          and <a href="{{RouteLink.OneLynkPrivacyPolicy}}" target="_blank">Privacy Policy</a>.
        </div>
      </div>

      <div *ngIf="!isLoggedIn" class="p-col-12 button-container" style="text-align: center;max-width:300px;width: 100%;margin:auto">
        <button pButton icon="fa fa-sign-in" type="button" class="button-action2" [disabled]="!realm" (click)="onClickProceedToLogin()"
                label="Proceed to Login">
        </button>
      </div>
      <div style="text-align: center;width: 100%;"> <div class="login-error" *ngIf="errorToolTipMsg">
        <button pButton type="button" [label]="errorToolTipMsg" class="icon-negative" icon="fa fa-warning"></button>
      </div></div>
      <div *ngIf="isLoggedIn" class="p-col-12 button-container">
        You are already logged in. Please click the button below to proceed to the Home page.
        <button pButton icon="fa fa-sign-in" type="button" class="button-action2" (click)="onClickProceedToHomePage()"
                label="Proceed to Home Page">
        </button>
      </div>
    </div>
  </div>
</form>
<div class="p-col-12"></div>
</body>
